export default "__VITE_ASSET__eqzAFq_s__"